window.HMAPBrandedCommsSettingsForm = function ($scope, brand) {
    var self = this;

    self.brandId = brand.id;
    self.load = function (data) {
        self.templateType = data.templateType;
    };
};
